import { Component, Input, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomerService } from '../../../../../../../../../../services/customer/customer.service';
import { CustomerMembership } from '../../../../../../../../../../models/membership';
import { openClimberAppInNewTabAsCustomer } from '../../../../../../../../../../utils-models';
import { OrganizationConfigService } from '../../../../../../../../../../services/organization-config/organization-config.service';

/**
 * Save a payment method for a membership that was paid for but never activated
 * because none was saved (PRO-1460).
 *
 * Opens the Climber App's finish-setup page for the membership, signed in as
 * its owner. That is the same page the owner reaches from their emailed
 * activation link and from the Climber App membership list, so a card saved
 * here activates the membership by the same route.
 *
 * The id-addressed URL is used rather than the `activation_url_token` twin:
 * staff are already authenticated as the owner by the login token, and the
 * token URL is reserved for the emailed link.
 */
@Component({
  selector: 'app-edit-recurring-customer-membership-add-payment-method',
  templateUrl: './edit-recurring-customer-membership-add-payment-method.component.html',
  styleUrls: ['./edit-recurring-customer-membership-add-payment-method.component.css']
})
export class EditRecurringCustomerMembershipAddPaymentMethodComponent implements OnInit, OnDestroy {

  @Input() membership: CustomerMembership;
  @Input() savedCallback: (successMessage: string) => undefined;
  @Input() saveClickedObservable: Observable<void>;
  @Output() loadingEvent = new EventEmitter<boolean>();
  @Output() serverErrorEvent = new EventEmitter<number>();

  public errorMessage = '';

  private saveClickedSubscription: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private orgService: OrganizationConfigService,
    private customerService: CustomerService
  ) {}

  ngOnInit() {
    this.saveClickedSubscription = this.saveClickedObservable.subscribe(() => {
      this.handleSave();
    });
  }

  ngOnDestroy() {
    this.saveClickedSubscription.unsubscribe();
  }

  private handleSave() {
    this.loadingEvent.emit(true);

    this.customerService
      .getCustomerClimberAppToken(this.membership.owner_id)
      .then(token => {
        const baseUrl = this.orgService.getOrganizationConfig().climber_app_base_url;
        openClimberAppInNewTabAsCustomer(
          token,
          this.membership.owner_id,
          baseUrl,
          baseUrl + 'membership/payment/' + this.membership.id.toString() + '/'
        );
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to manage this membership.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverErrorEvent.emit(reason.status);
        }
      })
      .finally(() => { this.loadingEvent.emit(false); });
  }

}
